<template>
  <div class="iframe-box">
    <info-video ref="stophls" ></info-video>
  </div>
</template>

<script>
import infoVideo from '../../components/video'
export default {
  name: 'Monitoring',
  components: {
    'info-video': infoVideo,
  },
  created () {
    const videoOptions = {
      accessToken: 'at.2hubqwejby1d27eq7zdn362f170368jj-6iihml2x44-04dtkov-9vmk3demr',
      videoList: [
        {
          deviceSerial: 'C59643719',
          channelNo: '1',
          name: '张北(C59643719)',
        },
        {
          deviceSerial: 'C59643746',
          channelNo: '1',
          name: '山东(C59643746)',
        },
      ],
    }
    window.top.videoOptions = videoOptions
  },
  // 组件销毁前
  beforeDestroy() {
    // 触发子组件方法
    this.$refs.stophls.stopHls()
  },
}
</script>

<style scoped>
.iframe-box {
  height: calc(100% - 0px);
  width: 100%;
}
.iframe-box iframe {
  height: 100%;
  width: 100%;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/videoSurveillance/videoSurveillance.vue